import React, { useEffect, useState } from 'react'
import $ from "jquery";
import { Button, Col, Form, FormControl, InputGroup, Navbar, Container, Row } from "react-bootstrap";
import MiSelector from './generic/MiSelector';
import TooltipIcon from './generic/TooltipIcon';
import GenericExplorer from './generic/GenericExplorer';
import HermanaTarjetaConfiguracion from "./usuario/HermanaTarjetaConfiguracion";
import NivelesAcceso from './generic/NivelesAcceso';


const ConfigApp = ({ perfil, ...props }) => {
    //console.log({'aaa': perfil.accessLevel})

    const [config, setConfig] = useState({ edicionHermanas: 'false' });
    //const [hermanasNivel, setHermanasNivel] = useState({ items: [] });
    const [nivel, setNivel] = useState(10)
    const [searchValue, setSearchValue] = useState("");


    useEffect(() => {
        //obtengo la configuración y la reobtengo cuando se setee
        //obtenerConfig()
        setConfig({ edicionHermanas: localStorage.getItem('edicionHermanas') })
        //console.log(localStorage.getItem('edicionHermanas'))
        // obtenerHermanasLevel(nivel)
        //console.log(hermanasNivel)
    }, [setConfig, nivel]);

    /* const obtenerHermanasLevel = (nivel) => {
         let settings = {
             url: `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&allUser=false&level=${nivel}`,
             method: "GET",
             timeout: 0,
             xhrFields: {
                 withCredentials: true,
             },
             headers: {
                 "Content-Type": "application/x-www-form-urlencoded",
             },
         };
         $.ajax(settings)
             .done((response) => {
                 setHermanasNivel(response);
                 //console.log(hermanasNivel)
                 //console.log(response.edicionHermanas)
             })
             .fail((error) => {
                 //console.log('error 33')
             });
     }*/

    const guardarConfig = (valor) => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/accessleveltwo/${valor === true ? 'true' : 'false'}`,
            method: "POST",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };
        //console.log(settings.url)

        $.ajax(settings)
            .done((response) => {
                setConfig({ edicionHermanas: valor === true ? 'true' : 'false' });
                localStorage.setItem('edicionHermanas', valor === true ? 'true' : 'false')
                //console.log('escribo : ', valor === true ? 'true' : 'false')
            })
            .fail((error) => {

            });
    };

    const handleChangeLevelTwo = (e) => {
        // console.log('micosa '+e)
        guardarConfig(e)
    }

    const handlePonNivel = (e) => {
        setNivel(e.target.value);
        //console.log(nivel)
    }

    return (
        <Form>
            <Form.Label><h4>Configuración de la aplicación</h4></Form.Label>
            <hr class="mt-2 mb-3" />
            <Form.Group className='ml-3'>

                <Form.Row>
                    <Form.Check
                        type="checkbox"
                        label={`Permitir actualizar datos del perfil a nivel hermanas (level 2)`}
                        defaultChecked={config.edicionHermanas === 'true'}
                        checked={config.edicionHermanas === 'true'}
                        onClick={((e) => { handleChangeLevelTwo(e.target.checked) })}
                    />
                </Form.Row>
            </Form.Group>

            <hr class="mt-2 mb-3" />

            <h6>Cambio de roles de acceso a la aplicación de Hermanas</h6>
            <br></br>

            <Form.Group className='form-inline ml-3'>
                <TooltipIcon className='mr-2' content={"Búsqueda por nombre, apellidos"} />
                <FormControl type="text" placeholder="Buscar hermana por nombre o apellido" value={searchValue} className='col-5'
                    onChange={e => setSearchValue(e.target.value)} />

                <InputGroup.Prepend className='ml-2'>
                    <InputGroup.Text>Filtro por ROL</InputGroup.Text>
                </InputGroup.Prepend>
                <NivelesAcceso title={props.title} onChange={handlePonNivel} value={nivel} className='col-3 ' userLevel={perfil.accessLevel} />
                <p className='ml-2'></p>
            </Form.Group>
            <Form.Group>
                <Container>
                    <Row >

                        {//console.log(hermanasNivel)
                        }
                        <Col className="input-group-text mt-1 col-12">Filtre y/o busque a la hermana para modificar su rol de acceso</Col>
                        {/*
                        <Col className="input-group-text mt-1 col-3">Username (email)</Col>
                        <Col className="input-group-text mt-1 col-3">Provincia, Comunidad</Col>
                        <Col title='El cambio de rol se hace efectivo en la siguiente autentificación en el programa' className="input-group-text mt-1 col-3">Roles disponibles</Col>
                        */}
                    </Row>

                    {/*(hermanasNivel.items.filter(item => `${item.name} ${item.firstSurname} ${item.secondSurname}`.toLowerCase().includes(searchValue.toLowerCase())).map(e =>
                        <Row className="bg-white mt-2" key={e.id}>
                            <Col className=' col-3'>{`${e.name}, ${e.firstSurname} ${e.secondSurname}`}</Col>
                            <Col className=' col-3'>{e.email ? e.email : ""}</Col>
                            <Col className=' col-3'>{`${e.sister?.destinations[0]?.province?.name ? e.sister?.destinations[0]?.province?.name : nivel === '10' ? 'Dirección General' : 'Sin Provincia'}
                                 ${e.sister?.destinations[0]?.community?.name ? `, ${e.sister?.destinations[0]?.community?.name}` : nivel === '10' ? '' : ', Sin Comunidad'} `}</Col>
                            <Col className=' col-3'>{e.sister?.destinations[0]?.province?.name && !e.sister?.destinations[0]?.province?.name.toLowerCase().includes('suprimida') && <MiSelector title='Si cambia su rol por uno inferior perderá su nivel en el siguiente acceso a la aplicación' id={e.id} accessLevel={e.accessLevel}/>}</Col>
                        </Row>

                    ))*/}

                    <GenericExplorer
                        className={'m-1'} url={`/usuarios?allUser=false&level=${nivel.length === 2 ? nivel.substr(1,1) === 'l' ? nivel.substr(0,1)+'&type=laico' : nivel.substr(0,1)+'&type=monja' : nivel}&findName=${searchValue}`}
                        //className={'m-1'} url={`/usuarios?type=Monja&allUser=false&level=${nivel}&findName=${searchValue}`} 
                        ItemAddCard={null}
                        userLevel={10}
                        apagadoExploraNuevaPestaña={true}
                        ItemCard={HermanaTarjetaConfiguracion}
                        nivelSeleccionado={nivel}
                    />
                </Container>

            </Form.Group>
        </Form>
    )
}

export default ConfigApp

/*
<Form.Control as="select" onChange={handlePonNivel} value={nivel} className='col-3 '>
                    <option value="2">Hermana</option>
                    <option value="3">Hermana Edición Perfil</option>
                    <option value="8">Secretaría Prov. Auxiliar</option>
                    <option value="9">Secretaría Provincial</option>
                    <option value="10">Administración General</option>
                    {perfil.accessLevel === 11 && <option value="11">Administración GLOBAL</option>}
                </Form.Control>
*/